jQuery(function ($) {
  $(document).ready(function () {
    //---Mobile Hero Slider---//
    $(".mobile-hero-slider").owlCarousel({
      nav: false,
      dots: true,
      loop: true,
      margin: 5,
      autoHeight: false,
      smartSpeed: 800,
      responsive: {
        0: {
          items: 1,
          stagePadding: 25
        },
        576: {
          items: 1,
          stagePadding: 100
        },
        768: {
          items: 1,
          stagePadding: 150
        },
        992: {
          items: 1
        }
      }
    });

    $(".digital-transform-slider").owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      dots: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 1200,
      smartSpeed: 450,
      autoplayHoverPause: true,
      animateOut: "animate__slideOutRight",
      animateIn: "animate__slideInRight",
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 3
        },
        1000: {
          items: 1
        }
      }
    });

    $(".digital-transform-mobile-slider").owlCarousel({
      loop: false,
      margin: 10,
      nav: false,
      dots: true,
      autoplay: false,
      autoplayTimeout: 5000,
      autoplaySpeed: 1200,
      smartSpeed: 450,
      autoplayHoverPause: true,
      animateOut: "animate__slideOutRight",
      animateIn: "animate__slideInRight",
      responsive: {
        0: {
          items: 1
        },
        576: {
          items: 1
        },
        768: {
          items: 1
        },
        992: {
          items: 1
        }
      }
    });

    $(".logo-slider").owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      dots: false,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplaySpeed: 1200,
      smartSpeed: 450,
      responsive: {
        0: {
          items: 2
        },
        600: {
          items: 3
        },
        1000: {
          items: 5
        }
      }
    });

    //---Casestudies Slider---//
    $(".casestuides-slider").owlCarousel({
      nav: true,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      loop: false,
      dots: false,
      margin: 25,
      autoHeight: false,
      stagePadding: 80,
      smartSpeed: 800,
      responsive: {
        0: { 
          items: 1,
          stagePadding: 0,
          margin: 15
        },
        768: { 
          items: 1,
          stagePadding: 0,
          margin: 20
        },
        1000: { items: 1 },
        1200: { items: 1.3 }
      }
    });

    // Iterate over each Forminator form
    $(".leadgen-form").each(function (index) {
      var currentForm = $(this);
      currentForm.addClass("dynamic-form-" + index);
      var interval = setInterval(function () {
        var successMessage = currentForm.find(
          ".forminator-response-message.forminator-success"
        );
        if (successMessage.length > 0 && successMessage.is(":visible")) {
          currentForm.find(".forminator-button-submit").hide();
          currentForm.find(".forminator-row").hide();
          currentForm.find(".download-btn").show();
          clearInterval(interval);
          console.log("Sucsess");
        }
      }, 500);
    });

    //----Profile Slider ----//
    $(".profile-slider").owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      dots: false,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $(".profile-mobile-slider").owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      dots: false,
      autoHeight: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $(".casestuides-mobile-slider").owlCarousel({
      loop: false,
      margin: 10,
      nav: false,
      dots: true,
      autoplay: false,
      autoplayTimeout: 5000,
      autoplaySpeed: 1200,
      smartSpeed: 450,
      autoplayHoverPause: true,
      responsive: {
        0: {
          items: 1,
          stagePadding: 30
        },
        576: {
          items: 1,
          stagePadding: 60
        },
        768: {
          items: 1,
          stagePadding: 100
        },
        992: {
          items: 1,
          stagePadding: 60
        }
      }
    });

    $(".awards-section-slider").owlCarousel({
      loop: false,
      margin: 10,
      nav: false,
      dots: true,
      responsive: {
        0: {
          items: 1,
          stagePadding: 30
        },
        576: {
          items: 1,
          stagePadding: 60
        },
        768: {
          items: 1,
          stagePadding: 100
        },
        992: {
          items: 1,
          stagePadding: 60
        }
      }
    });

    $('.about-testi-slider').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      dots: false,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $(".news-slider-about").owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      dots: false,
      autoplay: false,
      autoplayTimeout: 5000,
      autoplaySpeed: 1200,
      smartSpeed: 450,
      autoplayHoverPause: true,
      // animateOut: "animate__slideOutRight",
      // animateIn: "animate__slideInRight",
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1,
          stagePadding: 80
        }
      }
    });

    $('.slider-section-ii').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: false,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $('.reporting-visualization').owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-fill'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-fill'></i></div>"
      ],
      center: true,
      lazyLoad: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 800,
      // animateOut: "animate__fadeOut", // Remove animate__ prefix
      animateIn: "animate__fadeIn",
      onInitialized: function () {
        $('.announcements-slider .owl-item .item').addClass('animate__animated');
      },
      responsive: {
        0: {
          items: 1,
          margin: 10,
          stagePadding: 0,
          autoHeight: true,
          nav: false
        },
        768: {
          items: 1,
          margin: 15,
          stagePadding: 50
        },
        1000: {
          items: 1,
          margin: -200,
          stagePadding: 200
        }
      }
    })

    //---BPO Horizontal Accordion---//
    $(".single-accordian").on("click", function () {
      if ($(this).hasClass("active")) return;

      $(".single-accordian").removeClass("active");
      $(this).addClass("active");
    });

    // Custom Services Slider
    $(".custom-services-slider").owlCarousel({
      loop: true,
      margin: 25,
      nav: true,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      dots: false,
      responsive: {
        0: { items: 1 },
        768: { items: 2 },
        1000: { items: 2.2 },
        1200: { items: 2.4 }
      }
    });

    $(".custom-services-mobile-slider").owlCarousel({
      loop: true,
      margin: 20,
      nav: false,
      dots: false,
      navText: [
        "<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
        "<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>"
      ],
      dots: true,
      responsive: {
        0: { items: 1 },
        576: { items: 1 },
        768: { items: 1 },
        992: { items: 1 }
      }
    });

  });
});

jQuery(document).ready(function ($) {
  // Show profile 1 on page load
  var defaultProfileId = 11;
  $('.right-side .profile-card[data-profile="' + defaultProfileId + '"]')
    .fadeIn(0)
    .addClass("active");

  $('.card[data-profile="' + defaultProfileId + '"]').addClass("selected");

  // Handle click events
  $(".card[data-profile]").on("click", function (e) {
    e.preventDefault();

    var profileId = $(this).data("profile");

    if (profileId === $(".right-side .profile-card.active").data("profile"))
      return;

    $(".right-side .profile-card.active")
      .removeClass("active")
      .fadeOut(200, function () {
        $('.right-side .profile-card[data-profile="' + profileId + '"]')
          .fadeIn(200)
          .addClass("active");
      });

    $(".card[data-profile]").removeClass("selected");
    $(this).addClass("selected");
  });
});
 document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    let ticking = false;

    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    function handleScroll() {
        // Check if header element exists before accessing classList
        if (!header) {
            return;
        }

        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop) {
            header.classList.add('--hidden');
            header.classList.remove('sticky');
        } else {
            if (currentScroll > 0) {
                header.classList.remove('--hidden');
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }
        }

        lastScrollTop = currentScroll;
    }
});


